// src/pages/checkout/AddressForm.js
import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  addCustomerAddressApi,
  getStateGetByCountryIDApi,
} from "../CustomerCRUD";
import { toast } from "react-toastify";

// ✅ Yup Validation Schema
const validationSchema = Yup.object().shape({
  // fullName: Yup.string()
  //   // .matches(/^[A-Za-z ]$/, "Full name must only contain letters")
  //   .min(3, "Full name must be at least 3 characters")
  //   .max(30, "Full name must not exceed 30 characters")
  //   .required("Full name is required"),
  // mobileNumber: Yup.string()
  //   .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits")
  //   .required("Mobile number is required"),
  addressLine1: Yup.string()
    .min(5, "Address Line 1 must be at least 5 characters")
    .required("Address Line 1 is required"),
  addressLine2: Yup.string()
    .min(5, "Address Line 2 must be at least 5 characters")
    .required("Address Line 2 is required"),
  postalCode: Yup.string()
    .max(6, "Pincode must not exceed 6 digits")
    .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits")
    .required("Pincode is required"),
  stateId: Yup.string().required("State selection is required"),
  city: Yup.string().required("City is required"),
});

const CustomerAddressForm = ({
  initialAddress,
  onSave,
  customer,
  customerAddressID,
  setCustomerAddressID,
}) => {
  const [formData, setFormData] = useState({
    customerID: 0,
    fullName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    stateId: "", // store stateId from dropdown
    stateName: "", // store stateName separately for display
    postalCode: "",
    country: "India",
    mobileNumber: "",
  });
  const [states, setStates] = useState([]);

  useEffect(() => {
    fetchStates();
  }, []);

  const fetchStates = async () => {
    try {
      const res = await getStateGetByCountryIDApi(1);
      if (res.data.isSuccess) {
        setStates(res.data.responseObject);
      }
    } catch (error) {
      console.error("Error loading states:", error);
    }
  };

  function updateCustomerAddress() {
    alert("Update address feature coming soon!");
    setCustomerAddressID(1);
    // Handle update address logic here
  }
  // --------------Get Saved Address --------------
  // ✅ Pre-fill form when editing or if customer info exists
  useEffect(() => {
    if (initialAddress) {
      setFormData(initialAddress);
    } else if (customer) {
      setFormData((prev) => ({
        ...prev,
        fullName: customer.firstName + " " + customer.lastName,
        mobileNumber: customer.mobileNumber,
        customerID: customer.customerID,
      }));
    }
  }, [initialAddress, customer]);

  // --------------------------------------
  const initialValues = initialAddress
    ? initialAddress
    : {
        // fullName:
        //   formData.fullName ||
        //   (customer ? `${customer.firstName} ${customer.lastName}` : ""),
        // mobileNumber:
        //   formData.mobileNumber || (customer ? customer.mobileNumber : ""),
        customerID: formData.customerID || 0,
        addressLine1: formData.addressLine1 || "",
        addressLine2: formData.addressLine2 || "",
        city: formData.city || "",
        stateId: formData.stateId || "",
        postalCode: formData.postalCode || "",
        createBy: formData.customerID || 0,
        ipAddress: "127.0.0.1",
      };

  return (
    <Card className="shadow-sm p-3">
      <h5 style={{ color: "#4c934c" }}>🏠 Delivery Address</h5>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            const payload = {
              ...values,
              fullName: formData.fullName || "",
              phoneNumber: formData.phoneNumber || formData.mobileNumber || "",
              createBy: formData.customerID || 0,
              country: "India",
              ipAddress: "192.168.1.1",
            };
            // Save to localStorage
            localStorage.setItem("checkoutAddress", JSON.stringify(payload));
            const res = await addCustomerAddressApi(
              formData.customerID,
              values.stateId,
              values.city,
              values.postalCode,
              values.addressLine1,
              values.addressLine2,
              formData.customerID,
              "192.168.1.1"
            );
            if (res.data.isSuccess) {
              toast.success("Address saved successfully!");
              onSave(payload);
            } else {
              toast.error(res.data.message || "Failed to save address");
            }
          } catch (err) {
            console.error("Error saving address:", err);
            toast.error("Something went wrong while saving address");
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <Form noValidate onSubmit={handleSubmit} className="mt-3">
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="fullName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={(e) => {
                      // ✅ Allow only alphabets and spaces
                      if (/^[A-Za-z ]*$/.test(e.target.value)) {
                        handleChange(e);
                      } else {
                        toast.error("Only alphabets allowed in name");
                      }
                    }}
                    // isInvalid={touched.fullName && !!errors.fullName}
                    placeholder="Enter your full name"
                  />
                  {/* <Form.Control.Feedback type="invalid">
                    {errors.fullName}
                  </Form.Control.Feedback> */}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="mobileNumber">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={(e) => {
                      const val = e.target.value;

                      // ✅ Allow only digits
                      if (!/^\d*$/.test(val)) {
                        toast.error("Only digits allowed in mobile number");
                        return;
                      }

                      // ✅ Restrict to 10 digits
                      if (val.length > 10) {
                        toast.error(
                          "Mobile number cannot be more than 10 digits"
                        );
                        return;
                      }

                      handleChange(e);
                    }}
                    // isInvalid={touched.mobileNumber && !!errors.mobileNumber}
                    placeholder="Enter mobile number"
                  />
                  {/* <Form.Control.Feedback type="invalid">
                    {errors.mobileNumber}
                  </Form.Control.Feedback> */}
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="addressLine1" className="mb-3">
              <Form.Label>Address Line 1</Form.Label>
              <Form.Control
                type="text"
                name="addressLine1"
                value={values.addressLine1}
                onChange={handleChange}
                isInvalid={touched.addressLine1 && !!errors.addressLine1}
                placeholder="Street, House No, Area"
              />
              <Form.Control.Feedback type="invalid">
                {errors.addressLine1}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="addressLine2" className="mb-3">
              <Form.Label>Address Line 2</Form.Label>
              <Form.Control
                type="text"
                name="addressLine2"
                value={values.addressLine2}
                onChange={handleChange}
                isInvalid={touched.addressLine2 && !!errors.addressLine2}
                placeholder="Apartment, Landmark"
              />
              <Form.Control.Feedback type="invalid">
                {errors.addressLine2}
              </Form.Control.Feedback>
            </Form.Group>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="postalCode">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="text"
                    name="postalCode"
                    value={values.postalCode}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d{0,6}$/.test(val)) {
                        handleChange(e);
                      }
                    }}
                    isInvalid={touched.postalCode && !!errors.postalCode}
                    placeholder="Enter 6-digit Pincode"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.postalCode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="stateId">
                  <Form.Label>State</Form.Label>
                  <Form.Select
                    name="stateId"
                    value={values.stateId}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setFieldValue("stateId", selectedValue); // update Formik
                      const selected = states.find(
                        (s) => s.stateID === parseInt(selectedValue)
                      );
                      if (selected) {
                        setFieldValue("stateName", selected.stateName); // store stateName too
                      }
                    }}
                    isInvalid={touched.stateId && !!errors.stateId}
                  >
                    <option value="">-- Select State --</option>
                    {states.map((s) => (
                      <option key={s.stateID} value={s.stateID}>
                        {s.stateName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.stateId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={values.city}
                    onChange={handleChange}
                    isInvalid={touched.city && !!errors.city}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.city}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              {customerAddressID == 0 ? (
                <Button
                  type="submit"
                  variant="primary"
                  style={{
                    backgroundColor: "#4c934c",
                    border: "none",
                    color: "#fff",
                  }}
                >
                  Save Address
                </Button>
              ) : customerAddressID == 1 ? (
                <Button
                  className="btn btn-primary"
                  type="button"
                  variant="link"
                  onClick={updateCustomerAddress}
                >
                  Update Address
                </Button>
              ) : (
                <Button
                  type="submit"
                  variant="primary"
                  style={{
                    backgroundColor: "#4c934c",
                    border: "none",
                    color: "#fff",
                  }}
                >
                  Save Address
                </Button>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default CustomerAddressForm;
